import axios from 'axios';
import httpClient from '../httpService';
import { BSKT_MonHoc, CreateOrEditMonHocDto } from './models/MonHocModels';
import { ExecuteResultDto } from '../base-model/ExecuteResultDto';

const MonHocApiUrl = '/api/MonHoc/';

export const MonHocService = {
    getAll: async (): Promise<BSKT_MonHoc[]> => {
        return (await httpClient.get(MonHocApiUrl + 'getAll')).data?.data ?? [];
    },
    selectById: async (id: number): Promise<BSKT_MonHoc> => {
        return await httpClient.get(MonHocApiUrl + 'selectById/' + id);
    },
    selectAll: async (): Promise<BSKT_MonHoc[]> => {
        var result = await httpClient.get(MonHocApiUrl + 'selectAll');
        return result.data?.data ?? [];
    },
    createOrEdit: async (model: CreateOrEditMonHocDto): Promise<ExecuteResultDto> => {
        console.log('MonHocService.createOrEdit', model);
        return await httpClient.post(MonHocApiUrl + 'CreateOrEdit', model).then((response) => {
            return response.data;
        });
    },

    delete: async (id: number) => {
        return await httpClient.delete(MonHocApiUrl + 'delete/' + id).then((response) => {
            return response.data;
        });
    },
    insert: async (model: BSKT_MonHoc): Promise<BSKT_MonHoc> => {
        return await httpClient.post(MonHocApiUrl + 'insert', model).then((response) => response.data?.data ?? null);
    },
    update: async (model: BSKT_MonHoc): Promise<BSKT_MonHoc> => {
        return (await httpClient.put(MonHocApiUrl + 'update/' + model.ID_mon, model)).data?.data ?? null;
    }
};
